import moment from "moment";
import { formatPhoneNumberIntl } from "react-phone-number-input";
export const customerJsonObj = (
  values,
  isEdit,
  subscriptionsLength,
  dialCode,
  roleName,
  searchableValues,
  nonSearchableValues,
  startsOn,
  endsOn,
  selectedOfferCode,
  quantity,
  overrideResource,
  setOverrideResource,
  dynamicGroups,
) => {
  let attributesArray = [];
  let phoneNumber = formatPhoneNumberIntl(dialCode);
  let dialCodeWithPlus = phoneNumber.match(/^\+\d+(\s|$)/)[0];
  let restOfNumber = phoneNumber.slice(dialCodeWithPlus.length);
  let mobileNumberWithoutSpaces = restOfNumber.replace(/\s/g, "");
  let dialCodeWithoutSpaces = dialCodeWithPlus.replace(/\s/g, "");

  searchableValues.forEach((item) => {
    let value = item.value;

    if (typeof value === "object" && value !== null) {
      value = value.value;
    }

    if (value !== "") {
      attributesArray.push({
        name: item.name,
        value: value,
      });
    }
  });

  nonSearchableValues.forEach((item) => {
    let value = item.value;

    if (typeof value === "object" && value !== null) {
      value = value.value;
    }

    if (value !== "") {
      attributesArray.push({
        name: item.name,
        value: value,
      });
    }
  });

  if (dynamicGroups && Object.keys(dynamicGroups).length > 0) {
    Object.keys(dynamicGroups).forEach((groupName) => {
      const groupValues = dynamicGroups[groupName];

      if (!Array.isArray(groupValues)) return;
      const uniqueValues = [
        ...new Map(
          groupValues
            .filter((item) => item?.value && item.value.trim() !== "")
            .map((item) => [item.value.trim(), item]),
        ).values(),
      ];

      const formattedList = uniqueValues.map((item) => ({
        value: item.value.trim(),
      }));

      if (formattedList.length > 0) {
        const existingIndex = attributesArray.findIndex(
          (attr) => attr.name === groupName,
        );

        if (existingIndex !== -1) {
          attributesArray.splice(existingIndex, 1);
        }

        attributesArray.push({
          name: groupName,
          value: formattedList,
        });
      }
    });
  }

  const filteredResources = Object.values(overrideResource || {})
    .flat()
    .filter((resource) => resource.resourceName?.value?.trim())
    .map((resource) => ({
      resourceName: resource.resourceName.value,
      amount: parseFloat(resource.value) || 0,
    }));
  let subscriptionsArray = [];
  if (
    (roleName === "telcoAdmin" ||
      roleName === "telcoOperationUser" ||
      roleName === "telcoBusinessUser") &&
    startsOn &&
    selectedOfferCode
  ) {
    const convertedStartDateTime = moment(startsOn)
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    const convertedEndDateTime = moment(endsOn).endOf("day").format();
    const appendedZ = moment(convertedEndDateTime)
      .utc()
      .set({ hour: 23, minute: 59, second: 59 })
      .format();
    subscriptionsArray.push({
      customerId: values.accountNumber,
      offerCode: selectedOfferCode,
      validFrom: convertedStartDateTime,
      ...(endsOn && { validTo: appendedZ }),
      quantity: quantity,
      ...(filteredResources.length > 0 ? { resources: filteredResources } : {}),
    });
  }
  const jsonObj = JSON.stringify({
    customerId:
      roleName === "telcoAdmin" ||
      roleName === "telcoOperationUser" ||
      roleName === "telcoBusinessUser"
        ? values.accountNumber
        : values?.customerId,
    firstName: values?.firstName,
    lastName: values?.lastName,
    userName: values?.userName,
    tags: Array.isArray(values.categories)
      ? values.categories.map((item) => item.value)
      : values.categories && values.categories.value
        ? [values.categories.value]
        : [],
    email: values?.email,
    password: values?.password,
    mobile: parseInt(mobileNumberWithoutSpaces),
    addressLine1: values?.addressLine1,
    addressLine2: values?.addressLine2,
    country: values?.country?.value,
    state: values?.state?.value,
    city: values?.city?.value,
    zipCode: +values?.zipCode,
    isSSOUser: values?.isSSOUser,
    dialCode: dialCodeWithoutSpaces,
    ceiling: parseInt(values?.ceiling),
    floor: parseInt(values?.floor),
    billingProfile: { bdom: values.bdom.value },
    ...(attributesArray.length !== 0 && {
      attributeList: attributesArray,
    }),
    ...((roleName === "telcoAdmin" ||
      roleName === "telcoOperationUser" ||
      roleName === "telcoBusinessUser") && {
      subscriptions: subscriptionsArray,
    }),
  });
  subscriptionsArray = [];
  return jsonObj;
};

export const subscriptionsJsonObj = (customerData, customerId, id) => {
  let subscriptionID = "";
  customerData.subscriptionList.forEach((value, index) => {
    customerData.subscriptionList[index].subscribedOffers.forEach(
      (offer, offerIndex) => {
        if (id.original.id === offer.id) {
          subscriptionID = customerData.subscriptionList[index].subscriptionId;
        }
      },
    );
  });
  const currentTime = moment().format("YYYY-MM-DDTHH:mm:ss[Z]");
  const jsonObj = JSON.stringify({
    customerId: customerId,
    id: id.original.id,
    offerCode: id.original.offerCode,
    subscriptionId: subscriptionID,
    validTo: currentTime,
    ...(id.original.ceiling !== undefined && { ceiling: id.original.ceiling }),
    ...(id.original.floor !== undefined && { floor: id.original.floor }),
    ...(customerData?.subscriptionList[id?.index]?.deviceId && {
      deviceId: customerData?.subscriptionList[id?.index]?.deviceId,
    }),
  });
  return jsonObj;
};

export const simulateJsonObj = (
  values,
  customerId,
  urpOffers,
  fetchSummaryData,
  randomString,
) => {
  const matchingrateplan = urpOffers?.filter(
    (offer) => offer?.usageRatePlan[0]?.uomName === values?.uom?.label,
  );
  const subscripitionId = fetchSummaryData?.resources?.filter((resource) => {
    return matchingrateplan?.some(
      (offer) => offer?.offerCode === resource?.offerCode,
    );
  })[0]?.subscriptionId;
  const jsonObj = JSON.stringify({
    eventType: values.eventType,
    Id: customerId,
    transactionId: randomString,
    eventStartTime: moment(values.eventStartTime?._d).format(
      "YYYY-MM-DDTHH:mm:ss[Z]",
    ),
    subscriptionId: subscripitionId,
    eventEndTime: moment(values.eventEndTime?._d).format(
      "YYYY-MM-DDTHH:mm:ss[Z]",
    ),
    attributeList: [
      {
        name: values.uom.value,
        value: values.usageValue,
      },
    ],
  });
  return jsonObj;
};

export const documentDataFunction = (fetchDocumentData) => {
  let documentsOfCustomer = [];
  if (fetchDocumentData) {
    fetchDocumentData.forEach((value, index) => {
      documentsOfCustomer.push({
        documentName: value.documentName,
        fileName: value.fileName,
        documentType: value.documentType,
        uploadedtime: value.uploadedtime,
        uploadedBy: value.uploadedBy,
        status: value.status,
      });
    });
  }
  return documentsOfCustomer;
};

export const searchCustomerJsonData = (data, roleName) => {
  const transformedObject = {
    Name: `${data?.firstName} ${data?.lastName}`,
    Email: data?.email,
    ...(roleName === "telcoAdmin"
      ? {
          msisdn: data?.attributeList
            ?.find((attr) => attr.name.toLowerCase() === "msisdn")
            ?.value?.toString(),
          imsi: data?.attributeList
            ?.find((attr) => attr.name.toLowerCase() === "imsi")
            ?.value?.toString(),
        }
      : {
          Mobile: `${data?.dialCode}-${data?.mobile}`,
        }),
    CustomerId: data?.customerId,
    Address: `${data?.addressLine1}, ${data?.addressLine2}`,
    Status: data?.status || data?.Status || "",
  };

  return [transformedObject];
};

export const adjustJsonObject = (values, modalType, customerId) => {
  const adjustObject = {
    customerId: customerId,
    description: values?.description,
    source: "UI",
    type: modalType,
    balanceQuantity: -parseFloat(values.adjustmentAmount),
  };
  if (modalType === "Adjust") {
    adjustObject.resourceName = values?.resourceName;
  } else if (modalType === "Adjustment") {
    adjustObject.resourceName = values?.resourceName;
    adjustObject.offerCode = values?.offerCode;
    adjustObject.subscriptionId = values?.subscriptionId;
    adjustObject.balanceSpecId = values?.balanceItemSpecId;
    if (values?.validFrom) {
      adjustObject.validFrom = moment(values?.validFrom).format(
        "YYYY-MM-DDTHH:mm:ss[Z]",
      );
    }
    if (values?.validTo) {
      adjustObject.validTo = moment(values?.validTo).format(
        "YYYY-MM-DDTHH:mm:ss[Z]",
      );
    }
  } else if (modalType === "Recharge") {
    adjustObject.resourceName = values?.resourceName;
  }
  return adjustObject;
};
